<template lang='pug'>
  component(:is='tag' :href="isLink ? link : false" :target='target'
    @click='clickLink'
    :class="['linker',{imaged: img !== null}, addClass]"
    :download="download ? download : false")
    slot(name="before")
    .linker__image(v-if="img")
      img(:src="img" v-for="img in Array.isArray(img) ? img : [img]")
    span.linker__text(v-if="text" v-html="nl2br(text)")
    slot
</template>

<script>
  export default {
    name: "linker",
    props: {
      //base fields
      img: {type: [String,Array], default: null},
      text: {type: String, default: null},
      addClass: {type: String, default: ''},
      //link
      link: {type: [String,Boolean], default: false},
      directLink: String,
      pageId: {type:Number, default: 0}, //pageId for directLink
      newWin: {type: [Boolean, String], default: 'auto'},
      //click
      click: {type: Function, default: null},
      clickEval: {type: String, default: null},
      //goal
      goalName: {type: String, default: ''},
      goalAdd: {type: String, default: ''},
      //directLink scroll
      scrollOffset: {type: Function, default: null},
      scrollTime: {type: Number, default: 300},
      //other
      download: {type: String},
      altTag: {type: String, default: 'div'},
    },
    mounted: function () {},
    computed: {
      isLink: function () {return this.link;},
      tag: function () {return this.isLink || this.altTag === '' ? 'a' : this.altTag;},
      target: function () {return this.getNewWin() ? '_blank' : false;}
    },
    methods: {
      clickLink: function (e) {
        if (this.isDirect()) {
          e.preventDefault();
          let scrollOffs = this.scrollOffset ? this.scrollOffset() : 0;
          this.scrollToBlock(this.directLink,this.scrollTime, scrollOffs);
        }
        if (this.goalName) {
          //if (this.link || this.isDirect() || this.click || this.clickEval)
          this.goal(this.goalName, this.goalAdd);
          if (!this.isDirect() && !this.newWin) {
            e.preventDefault();
            let link = this.link;
            setTimeout(function () {
              location = link;
            },100)
          }
        }
        if (this.clickEval) eval(this.clickEval);
        if (this.click) this.click();
      },
      getNewWin: function() {
        if (this.newWin === 'auto')
          return this.link && this.link.substr(0, 4) === 'http';
        else return this.newWin;
      },
      isDirect: function () {return this.directLink && app.pageId === this.pageId}
    }
  }
</script>

<style lang='stylus'>
  @import "../base/mixins.styl"
  .linker
    display: block;
    text-decoration: none;
    .linker__image
      width: 100%
      full_imaged()
</style>